import { Component, ReactNode } from 'react'
import { Logger } from '@vp/ubik-logging'

interface Props {
  logger: Logger
  children: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class LoggingErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }
  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.props.logger.error(`Uncaught error in component: ${error.message}`, error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return null
    }

    return this.props.children
  }
}
